export default __webpack_public_path__ + "static/media/Group 5544.ad6cfafc.svg";